import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import { Map, GoogleApiWrapper,Marker,InfoWindow  } from 'google-maps-react';
import EuroCarPark from '../../assets/images/eurocarpark.png';



export  class LocationDetails extends React.Component{
    constructor(props){
        super(props);
        this.state={
            showingInfoWindow: true,  // Hides or shows the InfoWindow
          activeMarker: {},          // Shows the active marker upon click
          selectedPlace: {}
          };
    }
    onMarkerClick = (props, marker, e) =>
    this.setState({
      selectedPlace: props,
      activeMarker: marker,
      showingInfoWindow: true
    });

    onClose = props => {
      if (this.state.showingInfoWindow) {
        this.setState({
          showingInfoWindow: false,
          activeMarker: null
        });
      }
    };





    render(){
        let {selectedLocationId,selectedLocation}=this.props.locationDetail;
        return (<div><div className="card br">
            <div className="card-body mbb">
                <div className="card-title">
                    <h3><b>{selectedLocation.location && selectedLocationId!=''?selectedLocation.location.name:""}</b></h3>
                    <p><img className="w-max-100" src={EuroCarPark}/></p>
                    {
                        selectedLocation.location && selectedLocationId!=''?
                        <p className="address">
                            {`${selectedLocation.location.address.line1}, ${selectedLocation.location.address.line2}, ${selectedLocation.location.address.county}, ${selectedLocation.location.address.country}, ${selectedLocation.location.address.postCode}`}
                        </p>:null
                    }
                </div>

            </div>
            <div className="card-body">
                <div className="card-title">
                    <h5><strong>Accessing the underground car park</strong></h5>
                </div>
                <p className="card-text">Coming from the city centre, you can approach our car park via Mayor Street Upper or North Wall Quay. If approaching via Mayor Street Upper, drive past the back of The CCD and, to your right, you will see a ramp leading down to the car park entrance. If you are approaching The CCD from North Wall Quay, the easiest way in is to turn onto Park Lane (first turn left after The CCD coming from the city centre, last turn right before The CCD coming from Dublin Docklands). Take the first left off Park Lane and turn left down the ramp to the car park.</p>
                <p className="card-text">When you go down the ramp, turn right for The CCD car park. Please note that when you park, you must use the designated lift to exit the car park and ascend to Ground Level. For security reasons, all users of the car park must exit the building at ground level on the east side of The CCD, and do not have direct access into The CCD foyer. If you are attending an event at The CCD, simply walk around to the main entrance. </p>

            </div>
        </div>
        <div className="card mb-3">
            <div id="mapBox" className="map-body">
              <Map
                google={this.props.google}
                zoom={14}
                initialCenter={{ lat: 53.347925067311685, lng: -6.239476579134681}} >
                <Marker position={{ lat: 53.347925067311685, lng: -6.239476579134681}} 
                  onClick={this.onMarkerClick}
                  name={'Dublin Convention Centre '} />
                  <InfoWindow
                    marker={this.state.activeMarker}
                    visible={this.state.showingInfoWindow}
                    onClose={this.onClose} >
                    <div>
                      <h5>{this.state.selectedPlace.name}</h5>
                        {
                          selectedLocation.location && selectedLocationId!=''?
                          <p>{`${selectedLocation.location.address.line1},${selectedLocation.location.address.line2},${selectedLocation.location.address.county},${selectedLocation.location.address.country},${selectedLocation.location.address.postCode}`}</p>:null
                        }
            
                    </div>
                  </InfoWindow>
              </Map>
            </div>
          </div>
        </div>);
    }



}


LocationDetails.propTypes = {
 
    locationDetail: PropTypes.object
 
  
  
  };

  function mapStateToProps(state) {
    return {
      locationDetail: state.locationDetail
    };
  }
  

  
  export default connect(
    mapStateToProps,
    null
  )(
    GoogleApiWrapper({
        apiKey: 'AIzaSyD4SSfINuK2j1d95aXZNb4TBTkeYwn9Heg'
    })(LocationDetails));


// WEBPACK FOOTER //
// ./src/components/LocationDetails.jsx